import api from './api';

export const canchaService = {
  // Obtener canchas públicas de un establecimiento
  getCanchasByEstablecimiento: async (id) => {
    const response = await api.get(`/establecimientos/${id}/canchas`);
    return response.data;
  },
  // Obtener todas las canchas públicas
  getAllCanchas: async () => {
    const response = await api.get('/canchas');
    return response.data;
  },
  // Obtener todos los establecimientos públicos
  getAllEstablecimientos: async () => {
    const response = await api.get('/establecimientos');
    return response.data;
  },
  // Obtener solo las canchas del establecimiento actual
  getMisCanchas: async () => {
    const response = await api.get('/establishment/canchas');
    return response.data;
  },
  crearCancha: async (data) => {
    // El endpoint es /establishment/canchas
    const response = await api.post('/establishment/canchas', data);
    return response.data;
  },
  actualizarCancha: async (id, data) => {
    const response = await api.put(`/establishment/canchas/${id}`, data);
    return response.data;
  },
  eliminarCancha: async (id) => {
    const response = await api.delete(`/establishment/canchas/${id}`);
    return response.data;
  },

  buscarPublicas: async (params) => {
  const response = await api.get('/canchas/public-search', { params });
  return response.data;
},
};
